module.exports = __webpack_public_path__ + "img/hyu_gallery9.4b8290ec.jpg";